import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import React, { useEffect, useState } from 'react';
import LoadingSpinner from '@fff-web/fff-ui-shared/LoadingSpinner';
import UpgradeForm from '../UpgradeForm';
import { getEnv } from '../../../lib/utils/environment';
import { loadRecurly } from '../../../lib/utils/loadRecurly';
import { getBillingInformation, updateBillingInformation } from '../../../lib/services/billing';
import { IRecurlyPaymentForm, IUpgradeFormOnSubmit } from '../../../interfaces';

import '../../../lib/assets/recurly.css';

const RecurlyPaymentForm: React.FunctionComponent<IRecurlyPaymentForm> = ({ onSuccess }) => {
  const [load, setLoad] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cardInformation, setCardInformation] = useState();

  useEffect(() => {
    loadRecurly().then(() => setLoad(true));
    getBillingInformation().then((info) => {
      setCardInformation(info);
    });
  }, []);

  const handleSubmit = ({ id, type }: IUpgradeFormOnSubmit) => {
    setIsSubmitting(true);
    updateBillingInformation({
      token_id: id,
      type,
    }).then((response) => {
      onSuccess(response);
      setIsSubmitting(false);
    });
  };

  return !load ? (
    <LoadingSpinner />
  ) : (
    // @ts-expect-error - RecurlyProvider dep needs to be updated for this to work
    <RecurlyProvider publicKey={getEnv().recurlyPublicKey}>
      {/* @ts-expect-error - RecurlyProvider dep needs to be updated for this to work */}
      <Elements>
        <UpgradeForm
          onSubmit={handleSubmit}
          cardInformation={cardInformation}
          isDisabled={isSubmitting}
        />
      </Elements>
    </RecurlyProvider>
  );
};

RecurlyPaymentForm.defaultProps = {
  onSuccess: () => null,
};

export default RecurlyPaymentForm;
